<div>
  @if (waterQualityDetailsLoadComplete && waterQualityDetails) {
    <div class="container">
      <img class="backArrow" src="assets/img/ic_back.svg" (click)="navigateBack()">
      <span class="title-styling">
        {{'lang.water_quality_manager' | translate }}
      </span>

      <div class="border-style mt-4" style="padding: 10px;">
        <div class="row" style="padding: 15px;">
          <div class="col-12">
            <div>
              <span class="title-styling"> {{'lang.water_quality_manager' | translate }} </span>
            </div>
          </div>
        </div>

        <div class="row" style="margin-left: 5px; margin-bottom:10px;">
          <div class="col-3 wqm-details">

            <!-- Space Details -->
            <div class="wqm-details">
              <div class="wqm-name">
                <div style="margin-bottom: 10px;">
                  {{'lang.space_details' | translate }}
                </div>

                <div class="wqm-style">
                  <span class="wqm-sub-title">
                    {{'lang.spaces' | translate }}
                  </span>
                  <br>
                  @if (waterQualityDetails?.spaceDetails?.spaces?.spaceName; as spaceName) {
                    <span class="wqm-details-value">
                      {{ spaceName }}
                    </span>
                  } @else {
                    <span class="wqm-sub-title">-</span>
                  }
                </div>
                <br>

                <div class="wqm-style">
                  <span class="wqm-sub-title">
                    {{'lang.water_quality' | translate}}
                  </span>
                  <br>

                  <div class="status-row">
                    @if (getWaterQualityIcon(); as icon) {
                      <img [src]="icon" />
                    }
                    @if (waterQualityDetails?.spaceDetails?.waterQuality; as status) {
                      <span class="water-quality-status">
                        {{ getWaterQualityTranslationKey(status) | translate }}
                      </span>
                    } @else {
                      <span class="wqm-sub-title">-</span>
                    }
                  </div>

                  <div>
                    @if (waterQualityDetails?.spaceDetails?.lastChecked; as lastChecked) {
                      <span class="feature-value">
                        @if (isNumber(lastChecked)) {
                          {{ lastChecked | timestampToDate:'ago' }}
                        } @else {
                          {{ lastChecked }}
                        }
                      </span>
                    } @else {
                      <span class="wqm-sub-title">-</span>
                    }
                  </div>
                </div>
              </div>
            </div>

            <!-- Site Details -->
            <div class="wqm-details">
              <div class="wqm-name">
                <div style="margin-bottom: 10px;">
                  {{'lang.site_details' | translate }}
                </div>

                <div class="wqm-style">
                  <span class="wqm-sub-title">{{'lang.site_name' | translate }}</span> <br>
                  @if (waterQualityDetails?.spaceDetails?.sites?.siteName; as siteName) {
                    <span class="water-quality-status">
                      <a
                        [title]="siteName"
                        [routerLink]="['/sites/detail/', waterQualityDetails?.spaceDetails?.sites?.siteId]"
                        class="equipment-details-value">
                        {{ siteName | slice:0:30 }}{{ waterQualityDetails?.spaceDetails?.sites?.siteName?.length > 30 ? '...' : '' }}
                      </a>
                    </span>
                  } @else {
                    <span class="wqm-sub-title">-</span>
                  }
                </div>
                <br>
              </div>
            </div>
          </div>

          <div class="col-9">
            <div>
              <tabset class="m-0">

                <tab class="siteusers" (selectTab)="onSelect($event)">
                  <ng-template tabHeading>
                    @if (getSanitizationStatusIcon(); as icon) {
                      <img
                        [src]="icon"
                        class="me-2"
                      />
                    }
                    {{ 'lang.sanitization' | translate }}
                  </ng-template>

                  <div class="siteuser">
                    <app-sanitization
                      [sanitizationDetails]="waterQualityDetails?.sanitization"
                      [sanitizationEquipmentList]="waterQualityDetails?.sanitizationEquipment">
                    </app-sanitization>
                  </div>
                </tab>

                @if (hasTruSenseBalanceEquipment()) {
                  <tab class="siteusers" (selectTab)="onSelect($event)">
                    <ng-template tabHeading>
                      @if (getBalanceStatusIcon(); as icon) {
                        <img
                          [src]="icon"
                          class="me-2"
                        />
                      }
                      {{ 'lang.balance' | translate }}
                    </ng-template>

                    <div class="siteuser">
                      <app-balance [balanceDetails]="waterQualityDetails?.balance"></app-balance>
                    </div>
                  </tab>
                }

              </tabset>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</div>